export default __webpack_public_path__ + "static/media/Group878.4de49a4d.svg";